import { CHAINS } from "@toruslabs/xrpl-controllers";

import SimplexLogoURL from "@/assets/simplex-logo.png";
import SimplexLogoLightURL from "@/assets/simplex-logo-white.png";
import TopperLogoURL from "@/assets/topper-logo.svg";
import TopperLogoLightURL from "@/assets/topper-logo-white.svg";

export const enum TOPUP {
  SIMPLEX = "simplex",
  TOPPER = "topper",
}

export type TopUpProvider = {
  name: string;
  description: string;
  paymentMethod: string;
  fee: string;
  limit: string;
  logo: (darkMode: boolean) => string;
  supportedNetworks: string[];
  validCryptocurrencies: { name: string; value: string; label: string; symbol: string }[];
  validCurrencies: { value: string; label: string }[];
};

export const TopUpProviders: { [providerName: string]: TopUpProvider } = {
  [TOPUP.SIMPLEX]: {
    name: TOPUP.SIMPLEX,
    description: "topup.simplexTopUpServiceFee",
    paymentMethod: "Credit/ Debit Card",
    fee: "4.5% or 5 USD",
    limit: "$20,000/day, $50,000/mo",
    logo: (darkMode: boolean) => {
      return darkMode ? SimplexLogoLightURL : SimplexLogoURL;
    },
    validCryptocurrencies: [
      {
        name: "XRP",
        value: "XRP",
        label: "XRP",
        symbol: "XRP",
      },
    ],
    supportedNetworks: [CHAINS.XRPL_MAINNET],
    validCurrencies: [
      "AUD",
      "CAD",
      "DKK",
      "HUF",
      "NOK",
      "SEK",
      "CHF",
      "GBP",
      "USD",
      "PLN",
      "EUR",
      "JPY",
      "NZD",
      "CZK",
      "ZAR",
      "IDR",
      "AED",
      "AZN",
      "BGN",
      "BRL",
      "CLP",
      "COP",
      "CRC",
      "DOP",
      "GEL",
      "HKD",
      "ILS",
      "INR",
      "KRW",
      "KZT",
      "MAD",
      "MDL",
      "MXN",
      "MYR",
      "NAD",
      "NGN",
      "PEN",
      "PHP",
      "QAR",
      "RON",
      "SGD",
      "TWD",
      "UAH",
      "UYU",
      "VND",
      "SAR",
      "BOB",
      "CNY",
      "ALL",
      "ANG",
      "BBD",
      "BDT",
      "BMD",
      "BND",
      "BWP",
      "DJF",
      "EGP",
      "GHS",
      "GTQ",
      "TZS",
      "UGX",
      "XOF",
      "KGS",
      "MZN",
      "BAM",
      "MNT",
      "AMD",
      "KHR",
      "KYD",
      "LBP",
      "LKR",
      "PAB",
      "PGK",
      "PYG",
      "KES",
      "RSD",
      "SOS",
      "THB",
      "MOP",
      "MUR",
      "ISK",
      "JMD",
      "MKD",
      "BHD",
      "IQD",
      "JOD",
      "KWD",
      "OMR",
      "TRY",
    ].map((k) => {
      return { value: k, label: k };
    }),
  },
  [TOPUP.TOPPER]: {
    name: TOPUP.TOPPER,
    description: "topup.topperTopUpServiceFee",
    paymentMethod: "Credit / Debit Card",
    fee: "2.9% plus network fees",
    limit: "$2,500/day",
    logo: (darkMode: boolean) => {
      return darkMode ? TopperLogoLightURL : TopperLogoURL;
    },
    supportedNetworks: ["development", "staging"].includes(process.env.NODE_ENV ?? "") ? [CHAINS.XRPL_TESTNET] : [CHAINS.XRPL_MAINNET],
    validCryptocurrencies: [
      {
        name: "XRP",
        value: "XRP",
        label: "XRP",
        symbol: "XRP",
      },
    ],
    validCurrencies: [
      "AED",
      "ARS",
      "AUD",
      "BRL",
      "CAD",
      "CHF",
      "CNY",
      "CZK",
      "DKK",
      "EUR",
      "GBP",
      "HKD",
      "HRK",
      "HUF",
      "ILS",
      "INR",
      "JPY",
      "KES",
      "MXN",
      "NOK",
      "NZD",
      "PHP",
      "PLN",
      "RON",
      "SEK",
      "SGD",
      "USD",
    ].map((k) => {
      return { value: k, label: k };
    }),
  },
};
